module.exports = __webpack_public_path__ + "img/alert.b847cdea.svg";